import React from "react";
import { Route } from "react-router-dom";
import { CommonModule } from "uca-react-containers-library";
import { routes, routeTitle } from './components/pages/help/constants';

function PrivateRoute({ component: Component, dynamicTitle, title, banner, ...rest }) {
  const formattedBanner = banner.charAt(0).toUpperCase() + banner.slice(1);
  const faqRoutes = Object.values(routes);
  const isFaqDetailPage = rest.location.pathname.includes('faq-detail');
  const pathname = isFaqDetailPage ? rest.location.pathname.split('/').reverse()[1] : rest.location.pathname.substring(1);
  let updatedTitle = (faqRoutes && faqRoutes.includes(pathname) ? routeTitle[pathname] : title).replace(/{banner}/g, formattedBanner);;
  document.title = `${updatedTitle} | ${formattedBanner}`;
  return (
    <CommonModule.RouteProvider>
      <Route {...rest} render={(props) => <Component {...props} />} />
    </CommonModule.RouteProvider>
  );
}

export default PrivateRoute;
